module.exports = __webpack_public_path__ + "img/blms-icon-all-arrow.b59003a7.svg";